import { Badge } from '@cimplico/components';
import FyiLogo from '../../assets/fyi.png';

type ProviderBadgeProps = {
    provider: string;
};

function ProviderBadge({ provider }: ProviderBadgeProps): JSX.Element {
    if (provider.toUpperCase() === 'XERO') {
        return <Badge color="blue" label="XERO" shape="squared" size="small" variant="default" />;
    }

    if (provider.toUpperCase() === 'FYI') {
        return <img src={FyiLogo} className="w-6 h-6 shrink-0" />;
    }
    return <Badge color="gray" label={provider.toUpperCase()} shape="squared" size="small" variant="default" />;
}
export default ProviderBadge;
